import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.to-string.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "gai-correct"
};
var _hoisted_2 = {
  class: "gai-correct-tab"
};
var _hoisted_3 = {
  class: "gai-correct-content"
};
import { computed, nextTick, onMounted, ref } from 'vue';
import SubTab from '../../Components/SubTab.vue';
import GaiTop from '../../Components/GaiTop.vue';
import Review from './Review.vue';
import Works from './Works.vue';
import { skipUrl as skipUrlOpen } from '@/util/util';
import useUserStore from '@/stores/modules/user';
import { storeToRefs } from 'pinia';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var _storeToRefs = storeToRefs(useUserStore()),
      appAliasUrl = _storeToRefs.appAliasUrl;
    var tabs = [{
      name: '习练批阅',
      title: '批阅更多习练',
      value: 1,
      component: Review,
      exist: true,
      path: 'practice'
    }, {
      name: '作品管理',
      title: '查看更多作品',
      value: 2,
      component: Works,
      exist: true,
      path: 'course'
    }];
    var defaultIndex = ref(1);
    var domRef = ref(null);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var topTitle = computed(function () {
      return tabs[defaultIndex.value - 1].title;
    });
    var handleChangeTab = function handleChangeTab(item) {
      defaultIndex.value = item.value;
      nextTick(function () {
        handleRefresh();
      });
    };
    /**
     * 更多
     */
    var handleMore = function handleMore() {
      var tabItem = tabs.find(function (item) {
        return item.value === defaultIndex.value;
      });
      if (tabItem) {
        var url = "".concat(appAliasUrl.value, "?prepareLesson=%2Fmy%3Ftype%3D").concat(tabItem.path);
        skipUrlOpen(url, '_blank');
      }
    };
    /**
     * 刷新
     */
    var handleRefresh = function handleRefresh() {
      if (domRef.value) {
        domRef.value.refresh();
      }
    };
    onMounted(function () {
      handleRefresh();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(SubTab, {
        tabs: tabs,
        "default-index": defaultIndex.value,
        onChange: handleChangeTab
      }, null, 8, ["default-index"])]), _createVNode(GaiTop, {
        title: topTitle.value,
        onRefresh: handleRefresh,
        onMore: handleMore
      }, null, 8, ["title"]), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value), {
        ref_key: "domRef",
        ref: domRef
      }, null, 512))])]);
    };
  }
};